import {gql, useQuery} from "@apollo/client";
import {License, LicenseType} from "../../../../schema";
import UnexpectedErrorScene from "../../../system/UnexpectedErrorScene";
import React, {useMemo} from "react";
import LicenseTile from "./LicenseTile";

type LicensesTab = {
  licenseeId: string;
}

export function LicensesTab({licenseeId}: LicensesTab) {

  const {loading, data, error} = useQuery<LicensesQuery>(query, {
    variables: {id: licenseeId}
  });

  const types = useMemo(() => {
    const maps = new Map<string, LicenseType>();
    data?.licenseTypes.forEach(type => {
      maps.set(type.id, type);
    });
    return maps;
  }, [data]);

  if (error) {
    return <UnexpectedErrorScene
      error={error}
      errorInfo={null}
      eventId={null}
    />;
  }

  return (
    <div className="grid lg:grid-cols-3 lg:gap-4 gap-y-4 py-10">
      {!loading && !!data && (
        <>
          {data?.licenses.map((license) =>
            <LicenseTile key={license.id} license={license} types={types} withSeats={true}/>
          )}
        </>
      )}
    </div>
  );
}

interface LicensesQuery {
  licenses: License[];
  licenseTypes: LicenseType[];
}

const query = gql`
  query LicensesQuery($id: ID!) {
    licenses: licenseeLicenses(licenseeId: $id) {
      id
      typeId
      amount
      currency
      expiresAt
      expiresIn
      seats
      periods {
        start
        end
        excludeFromExperience
      }
      version
      expired
      active
    },
    licenseTypes: licenseTypes {
      id
      name
    }
  }
`;
